import { render, staticRenderFns } from "./ActionForm.vue?vue&type=template&id=649f5108&"
import script from "./ActionForm.vue?vue&type=script&lang=ts&"
export * from "./ActionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports